import ArrayTable from '../ArrayTable'
import ApiTable from '../EditTable'
import PanelTable from '../PanelTable'
import ChunkApiTable from '../ChunkApiTable'

export const createTableViewResolver = ({
  uischema,
  saveType,
  isLoadSEARCH,
  fieldKey,
  fieldName,
}) => {
  let { get, search } = uischema?.loadData || {}
  let TableView = ArrayTable

  if (saveType === 'api' || isLoadSEARCH) {
    let enablePagination =
      (get && get.enablePagination) || (search && search.enablePagination)
    TableView = enablePagination ? ApiTable : ChunkApiTable
  } else if (saveType === 'formPanel') {
    TableView = PanelTable
  }

  return {
    TableView,
    tableViewProps: {
      fieldKey,
      fieldName,
    },
  }
}
